import { lazy, Suspense } from "react";
import { useLocation } from "react-router-dom";
import LoadingScreen from "../../../shared/components/LoadingScreen";
import AuthGuard from "../../../shared/guards/AuthGuard";
import DashboardLayout from "../../../shared/layouts/dashboard";


const Loadable = (Component) => (props) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { pathname } = useLocation();

    return (
        <Suspense fallback={<LoadingScreen isDashboard={pathname.includes('/dashboard')} />}>
            <Component {...props} />
        </Suspense>
    );
};
const Shops = Loadable(lazy(() => import('../view/Shops')));
const ShopForm = Loadable(lazy(() => import('../components/ShopForm')));
const ShopStepperForm = Loadable(lazy(() => import('../components/ShopStepperForm')));

export const ShopsRoutes = [
    // Dashboard Routes
    {
        path: 'dashboard',
        element: (
            <AuthGuard>
                <DashboardLayout />
            </AuthGuard>
        ),
        children: [
            { path: 'my-shops', element: <Shops /> },
            { path: 'my-shops/add-shop', element: <ShopForm /> },
            { path: 'shops/add-shop', element: <ShopStepperForm /> },
        ],
    },
];
